import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';

interface ActionButtonsFormularioAgriculturaProps {
  disabled?: boolean;
}

const ActionButtonsFormularioAgricultura: React.FC<
  ActionButtonsFormularioAgriculturaProps
> = ({ disabled }) => {
  const { formulario, setPartialForm, salvarRascunho, enviarAprovacao } =
    useFormularioSecretariaMunicipalAgriculturaStore();
  const totalSteps = 8;
  const stepAtual: any = formulario?.step_atual;
  const navigate = useNavigate();

  const handleSalvarRascunho = async () => {
    const response = await salvarRascunho();
    if (response) {
      alert('Rascunho salvo com sucesso');
      navigate('/pacote-de-formularios');
    } else {
      alert('Erro ao salvar rascunho');
    }
  };

  const handleEnviarAprovacao = async () => {
    const response = await enviarAprovacao();
    if (response) {
      alert('Formulário concluido com sucesso');
      navigate('/pacote-de-formularios');
    } else {
      alert('Erro ao concluir formulário');
    }
  }

  const handleAvançar = () => {
    salvarRascunho();
    setPartialForm('step_atual', stepAtual + 1);
  };

  const handleVoltar = () => {
    setPartialForm('step_atual', stepAtual - 1);
  };

  return (
    <Box
      display={'flex'}
      justifyContent={'flex-end'}
      gap={2}
      mt={4}
      width={'100%'}
    >
      {/* voltar um formulario */}
      {stepAtual > 1 && (
        <Button variant='outlined' color='primary' onClick={handleVoltar}>
          Voltar
        </Button>
      )}
      <Button
        variant='contained'
        color='primary'
        onClick={handleSalvarRascunho}
      >
        Salvar como rascunho
      </Button>
      {formulario?.step_atual === totalSteps ? (
        <Button variant='outlined' color='primary' onClick={handleEnviarAprovacao}
          disabled={disabled}
        >
          Enviar para aprovação
        </Button>
      ) : (
        <Button
          variant='contained'
          color='primary'
          onClick={handleAvançar}
          disabled={disabled}
        >
          Avançar
        </Button>
      )}
    </Box>
  );
};

export default ActionButtonsFormularioAgricultura;
